let showErrorAlertFn: ((msg: string, onConfirm?: () => void) => void) | null =
  null;

export const setShowErrorAlert = (
  fn: (msg: string, onConfirm?: () => void) => void
) => {
  showErrorAlertFn = fn;
};

export const showGlobalErrorAlert = (msg: string, onConfirm?: () => void) => {
  if (showErrorAlertFn) showErrorAlertFn(msg, onConfirm);
};
